import { FC } from 'react';

import { Tooltip } from '@/components/ui';

interface KPICardProps {
    label: string;
    value: string | number;
    sublabelText: string;
    primary?: boolean;
    warn?: boolean;
    tooltip?: string;
}

export const InternalKPICard: FC<KPICardProps> = ({ label, value, sublabelText, primary, warn, tooltip }) => (
    <div className={`relative p-3 border ${primary ? 'bg-neutral-900 border-neutral-900' : 'bg-white border-neutral-200/80'}`}>
        <div className="flex items-center gap-1 mb-0.5">
            <div className={`text-[9px] uppercase tracking-wide ${primary ? 'text-neutral-400' : 'text-neutral-500'}`}>{label}</div>
            {tooltip && (
                <Tooltip content={tooltip}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className={`w-3 h-3 ${primary ? 'text-neutral-600' : 'text-neutral-400'} cursor-help`}>
                        <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                    </svg>
                </Tooltip>
            )}
        </div>
        <div className={`text-lg font-semibold ${primary ? 'text-white' : warn ? 'text-amber-600' : 'text-neutral-900'}`}>{value}</div>
        <div className={`text-[9px] ${primary ? 'text-neutral-500' : 'text-neutral-400'}`}>{sublabelText}</div>
    </div>
);
